import { Box } from '@mui/material';
import React from 'react';
import { useController } from 'react-hook-form';

import FormFields from '../../FormFields';
import { FormFieldDefinition } from '../../ResourceForm';

export const DESTROY_FIELD = '_destroy';
export const TEMP_ID_FIELD = 'tempId';
const DESTROYED_OPACITY = 0.5;

interface NestedFormFieldsProps {
  attribute: string;
  fields: FormFieldDefinition[];
  index?: number;
  value?: any;
  persisted: boolean;
  multiple?: boolean;
  storageKey?: string;
}

const NestedFormFields = ({ attribute, fields, index, multiple, persisted, storageKey }: NestedFormFieldsProps) => {
  const prefix = `${attribute}.${index}`;
  const {
    field: { value: isDestroyed },
  } = useController({ name: `${prefix}.${DESTROY_FIELD}` });

  if (isDestroyed && !persisted) {
    return null;
  }

  return (
    <Box
      component="fieldset"
      sx={{
        border: '1px',
        borderColor: 'gray.200',
        borderRadius: 'base',
        marginBottom: '1em',
        flexGrow: 1,
        padding: multiple ? '1em' : undefined,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5em',
          width: '100%',
          opacity: isDestroyed ? DESTROYED_OPACITY : 1,
        }}
      >
        <FormFields fields={fields} prefix={prefix} storageKey={storageKey} />
      </Box>
    </Box>
  );
};

export default NestedFormFields;
